import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "./UserContext"; // adjust path if needed

const LogoutOnLockout = () => {
  const { logout } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    alert("Your account has been locked out by an administrator. You have been logged out.");
    
    // Call logout from UserContext to properly clear user state
    logout();
    
    // Remove token explicitly (safe redundancy)
    localStorage.removeItem("token");
    
    // Redirect to login
    navigate("/login", { replace: true });
  }, [logout, navigate]);

  return null; // no UI, just handles side-effect
};

export default LogoutOnLockout;
